
// Action: file_editor create /app/frontend/src/pages/ContactPage.js --file-text "
import React from 'react';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <div data-testid="contact-page" className="pt-24">
      <Contact />
    </div>
  );
};

export default ContactPage;

// Observation: Create successful: /app/frontend/src/pages/ContactPage.js